import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { cn } from '@/lib/utils';

export function Clients() {
  const { data, isLoading } = useQuery({
    queryKey: ['clients'],
    queryFn: () => api.getClients(),
  });

  const clients = data?.clients || [];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold">Clients</h2>
          <p className="text-sm text-muted-foreground">
            Manage trading clients and accounts
          </p>
        </div>
        <button className="h-9 px-4 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90">
          + Add Client
        </button>
      </div>

      <div className="rounded-lg border bg-card">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b bg-muted/50">
                <th className="px-6 py-3 text-left text-sm font-medium text-muted-foreground">Name</th>
                <th className="px-6 py-3 text-left text-sm font-medium text-muted-foreground">FCM Account</th>
                <th className="px-6 py-3 text-center text-sm font-medium text-muted-foreground">Type</th>
                <th className="px-6 py-3 text-center text-sm font-medium text-muted-foreground">Exemption</th>
                <th className="px-6 py-3 text-center text-sm font-medium text-muted-foreground">Status</th>
                <th className="px-6 py-3 text-right text-sm font-medium text-muted-foreground">Actions</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={6} className="px-6 py-8 text-center text-muted-foreground">
                    Loading clients...
                  </td>
                </tr>
              ) : clients.length === 0 ? (
                <tr>
                  <td colSpan={6} className="px-6 py-8 text-center text-muted-foreground">
                    No clients found
                  </td>
                </tr>
              ) : (
                clients.map((client) => (
                  <tr key={client.id} className="border-b last:border-0 hover:bg-muted/50">
                    <td className="px-6 py-4 font-medium">{client.name}</td>
                    <td className="px-6 py-4 font-mono text-sm">
                      {client.fcmAccountId || '-'}
                    </td>
                    <td className="px-6 py-4 text-center">
                      <span className={cn(
                        'px-2 py-1 rounded text-xs font-medium',
                        client.clientType === 'HEDGER' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'
                      )}>
                        {client.clientType}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      {client.hasHedgeExemption ? (
                        <span className="px-2 py-1 rounded bg-green-100 text-green-700 text-xs font-medium">
                          Yes
                        </span>
                      ) : (
                        <span className="text-muted-foreground">-</span>
                      )}
                    </td>
                    <td className="px-6 py-4 text-center">
                      <span className={cn(
                        'px-2 py-1 rounded-full text-xs font-medium',
                        client.isActive ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'
                      )}>
                        {client.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-right">
                      <button className="text-sm text-primary hover:underline">
                        Edit
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
